import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllWaiters,
  filterWaitersTurnOver,
} from "../../services/waitersService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getWaiters(restaurant) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllWaiters, token, restaurant.restaurantId);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_WAITERS_SUCCESS,
        waiters: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* filterAreasTurnOverSaga({
  filteredWaiterIds,
  startDate,
  endDate,
  selectedRestaurant,
}) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      filterWaitersTurnOver,
      token,
      filteredWaiterIds,
      startDate,
      endDate,
      selectedRestaurant
    );
    if (response[0] === 200) {
      yield put({
        type: actions.FILTER_BY_WAITERS_SUCCESS,
        waitersTurnOver: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_WAITERS_REQUEST, getWaiters),
    yield takeEvery(actions.FILTER_BY_WAITERS_REQUEST, filterAreasTurnOverSaga),
  ]);
}
